import React, { useState, useEffect, useRef } from "react";
import { Doughnut } from "react-chartjs-2";
import "chartjs-plugin-datalabels";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";

//Custom Components
import ChartCard from "../../components/Cards/ChartCard";
import CardSwitch from "../../components/Cards/CardSwitch";
import CardLegend from "../../components/Cards/CardLegend";
import Loader from "../../components/Loader/Loader";
import { Wrapper } from "../../components";

//MockData
import totalPeopleConfig from "./totalPeopleConfig";
import totalSegmentedPeopleConfig from "./totalSegmentedPeopleConfig";
import {COUNTRY_STATISTICS_BASE_URL} from '../../constants';

//Icons
import { ReactComponent as Pie } from "../../img/icons/3_Pie2.svg";
import { ReactComponent as Pie2 } from "../../img/icons/3_Pie4.svg";

//Utils

import {formatNumber} from '../../utils/formatNumber';

const useStyles = makeStyles((theme) => ({
  innerGrid: {
    position: "relative",
  },
  chartContainer: {
    position: "relative",
    width: "100%",
    height: "55vh",
    [theme.breakpoints.down("lg")]: {
      height: "37vh",
    },
  },
}));

const EvacuadosPorProvincia = (props) => {
  const classes = useStyles();
  const chartEl = useRef(null);
  const { campaign, year } = props;

  const APIURL = `${COUNTRY_STATISTICS_BASE_URL}${campaign}`;

  const [visible, setVisible] = useState("left");
  const [homeData, setHomeData] = useState(null);
  const [, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  async function getData() {
    try {
      setLoading(true);
      const homeData = await axios.get(APIURL).then((data) => {
        return data.data;
      });
      setHomeData(homeData);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleVisible = (newVisible) => {
    setVisible(newVisible);
    getData();
  };

  const totalSumMen = homeData
    ? homeData.map(
        (data) => formatNumber(data.totalMen + data.totalBoys + data.totalElderMen)
      )
    : [];
  const totalSumWomen = homeData
    ? homeData.map(
        (data) => formatNumber(data.totalWomen + data.totalGirls + data.totalElderWomen)
      )
    : [];

  const totalElderWomen = homeData
    ? homeData.map((data) => formatNumber(data.totalElderWomen))
    : [];

  const totalWomen = homeData ? homeData.map((data) => formatNumber(data.totalWomen)) : [];
  const totalGirls = homeData ? homeData.map((data) => formatNumber(data.totalGirls)) : [];

  const totalElderMen = homeData
    ? homeData.map((data) => formatNumber(data.totalElderMen))
    : [];

  const totalMen = homeData ? homeData.map((data) => formatNumber(data.totalMen)) : [];
  const totalBoys = homeData ? homeData.map((data) => formatNumber(data.totalBoys)) : [];

  const totalPeopleData = totalPeopleConfig([totalSumWomen, totalSumMen]);
  const totalSegmentedPeopleData = totalSegmentedPeopleConfig([
    totalElderWomen,
    totalElderMen,
    totalWomen,
    totalMen,
    totalGirls,
    totalBoys,
  ]);

  const totalPeoplelegend = [
    {
      legend: "Total Mujeres",
      color: "#A48AD4",
      border: "#7E57C2",
      amount: totalSumWomen,
    },
    {
      legend: "Total Hombres",
      color: "#4EC2F7",
      border: "#03A9F4",
      amount: totalSumMen,
    },
  ];
  const totalSegmentedPeoplelegend = [
    {
      legend: "Mujeres adultas mayores",
      color: "#FFC99D",
      border: "#FFB274",
      amount: totalElderWomen,
    },
    {
      legend: "Hombres adultos mayores",
      color: "#FFDF96",
      border: "#FFCD5B",
      amount: totalElderMen,
    },
    {
      legend: "Mujeres jóvenes y adultas",
      color: "#A48AD4",
      border: "#7E57C2",
      amount: totalWomen,
    },
    {
      legend: "Hombres jóvenes y adultos",
      color: "#4EC2F7",
      border: "#03A9F4",
      amount: totalMen,
    },
    {
      legend: "Niñas",
      color: "#F19AAD",
      border: "#CD5D74",
      amount: totalGirls,
    },
    {
      legend: "Niños",
      color: "#B6E19F",
      border: "#7AB45B",
      amount: totalBoys,
    },
  ];

  return (
    <Wrapper>
      <Grid container spacing={1} justify="center">
        <Grid className={classes.innerGrid} item xs={12} sm={10} md={10}>
          <CardSwitch sendData={handleVisible}>
            <Pie />
            <Pie2 />
          </CardSwitch>
          {visible === "left" && (
            <ChartCard
              title={totalPeopleData.title}
              subheader={totalPeopleData.subtitle}
              expand={true}
              bottom={60}
              year={year}
            >
              {totalPeopleData.type === "doughnut" && (
                <div className={classes.chartContainer}>
                  {loading ? (
                    <Loader />
                  ) : (
                    <>
                      <Doughnut
                        data={totalPeopleData.data}
                        height={totalPeopleData.height}
                        options={totalPeopleData.options}
                        ref={chartEl}
                      />
                      <CardLegend options={totalPeoplelegend} />
                    </>
                  )}
                </div>
              )}
            </ChartCard>
          )}
          {visible === "right" && (
            <ChartCard
              title={totalSegmentedPeopleData.title}
              subheader={totalSegmentedPeopleData.subtitle}
              expand={true}
              height={85}
              bottom={60}
              year={year}
            >
              {totalSegmentedPeopleData.type === "doughnut" && (
                <div className={classes.chartContainer}>
                  {loading ? (
                    <Loader />
                  ) : (
                    <>
                      <Doughnut
                        data={totalSegmentedPeopleData.data}
                        height={totalSegmentedPeopleData.height}
                        options={totalSegmentedPeopleData.options}
                      />
                      <CardLegend options={totalSegmentedPeoplelegend} />
                    </>
                  )}
                </div>
              )}
            </ChartCard>
          )}
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default EvacuadosPorProvincia;
